import React from 'react';
import PropTypes from 'prop-types';
import CheckIcon from '@material-ui/icons/Check';

const WizardProgress = ({ activeStep, steps }) => (
  <div className="mb-10">
    <div className="flex items-start justify-between max-w-140 mx-auto">
      {steps.map(({ key, title }, index) => {
        const isComplete = index < activeStep;
        const isActive = index === activeStep;

        return (
          <React.Fragment key={key}>
            <div className="flex flex-col items-center relative z-10 w-20 sm:w-30">
              <div
                className={`h-10 w-10 rounded-full flex items-center justify-center border-2 font-semibold transition-all duration-400 ${
                  isComplete || isActive
                    ? 'bg-easter border-easter text-white shadow-button'
                    : 'bg-white border-alto text-dusty'
                }`}
              >
                {isComplete ? <CheckIcon fontSize="small" /> : index + 1}
              </div>
              <span
                className={`text-xs mt-2 text-center ${
                  isActive ? 'text-ebony font-semibold' : 'text-dusty'
                }`}
              >
                {title}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`flex-1 h-1 mt-5 -mx-3 sm:-mx-5 ${
                  index < activeStep ? 'bg-easter' : 'bg-alto'
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
    <p className="text-center text-xs text-dusty mt-4">
      Step {activeStep + 1} of {steps.length}
    </p>
  </div>
);

WizardProgress.propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.array.isRequired,
};

export default WizardProgress;
